import { render, staticRenderFns } from "./FormGeneratorView.vue?vue&type=template&id=04d2f988&scoped=true&"
import script from "./FormGeneratorView.vue?vue&type=script&lang=js&"
export * from "./FormGeneratorView.vue?vue&type=script&lang=js&"
import style0 from "./FormGeneratorView.vue?vue&type=style&index=0&id=04d2f988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2f988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
